type ToMoneyOptions = {
    hideSymbol?: boolean;
    hideFractionDigits?: boolean;
};

export const toMoney = (value: number, options?: ToMoneyOptions): string => {
    const rawValue =
        options?.hideFractionDigits === true
            ? parseInt(value.toFixed(0))
            : value;

    const fractionDigits = options?.hideFractionDigits === true ? 0 : 2;

    const formatted = rawValue.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
    });

    return options?.hideSymbol === true
        ? formatted.replace('R$ ', '')
        : formatted;
};

type ToPercentOptions = {
    fractionDigitsAmount?: number;
};

export const toPercent = (value: number, options?: ToPercentOptions) => {
    const fractionDigits = options?.fractionDigitsAmount || 2;

    return (value / 100).toLocaleString('pt-BR', {
        style: 'percent',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
    });
};
